import Modal from "../../_bootstrapModalExtensions";
import Classes from "../../_classes";
import * as Url from "../../Utils/UrlUtil";
import Interfaces from "../../_interfaces";
import * as Helpers from "../../DxGridFunctions/Helpers";

function CheckRealtiesStatuses(): void {
    let processId: number = $('#get-related-clients-from-takarnet').data('process-id');

    $.ajax({
        type: 'POST',
        url: window.ETDR_RD.appConfig["UrlAction.CheckRealtiesStatuses"],
        data: { 'processId': processId }
    })
    .done((result) => {
        if (result.checkedEstates === result.totalEstates) {
            GetRelatedClients(processId);
        }
        else if (result.checkedEstates == 0) {
            let modalText: string = 'Az Ingatlanok lapon nem található ellenőrzött ingatlan. Az ingatlan ellenőrzését az Ingatlan lapon, az adott ingatlan sorához tartozó <span class="icon-ico-check-square-o takarnet-realty-check"></span> ikonnal tudja elvégezni.';

            Modal.showAlertWindow(modalText, '', 'Rendben', true, () => { $(this).fadeOut(450); });
        }
        else {
            let modalText: string = 'Az Ingatlanok lapon található ellenőrizetlen ingatlan. Az ellenőrizetlen ingatlanok adatai nem lesznek átvéve. Ennek ellenére folytatja?';

            Modal.showConfirmationWindowAsync(modalText, '', () => { GetRelatedClients(processId); }, () => { $(this).fadeOut(450); }, 'Igen', 'Nem');
        }
    });
}

function GetRelatedClients(processId: number): void {
    const checkedRealtiesSettings: Classes.BootstrapModalWithAjaxContentSettings = GetCheckedRealtiesSettings();
    Modal.showBootstrapModalWithAjaxContent(checkedRealtiesSettings);

    function GetCheckedRealtiesSettings(): Classes.BootstrapModalWithAjaxContentSettings {
        let checkedRealtiesTemplate: string = window.ETDR_RD.appConfig['UrlTemplate.CheckedRealtiesModalWindow'];
        let checkedRealtiesSaveUrlTemplate: string = window.ETDR_RD.appConfig['UrlAction.CheckedRealtiesModalWindowSaveUrl'];
        let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

        settings.title = 'Lekérdezni kívánt ingatlanok kiválasztása';
        settings.contentUrl = Url.createUrlFromTemplate(checkedRealtiesTemplate, { processId: processId });
        settings.saveUrl = checkedRealtiesSaveUrlTemplate;
        settings.callback = () => callback();
        settings.enableUnobtrusiveValidation = false;
        settings.showSaveButton = true;
        settings.infoText = '';
        settings.saveText = 'Tovább';
        settings.showRejectButton = false;
        settings.infoIconText = 'Ebben az ablakban csak a Takarnet által sikeresen ellenőrzött ingatlanokat jelenítjük meg. A pipával kiválasztott ingatlanokhoz tartozó rendelkezni jogosultak fognak megjelenni a Tovább gombra való kattintást követően.';

        return settings;
    }

    function callback(): void {
        const grid: Interfaces.MVCxClientGridViewForCheckedRealties = window['CheckedRealties'] as Interfaces.MVCxClientGridViewForCheckedRealties;
        const estateIds: number[] = grid.cpSelectedKeys.map((val) => parseInt(val));

        const contentUrl: string = Url.createUrlFromTemplate(window.ETDR_RD.appConfig['UrlTemplate.RelatedClientsModalWindow'], { estateIds: estateIds, processId: getProcessIdFromPage() });
        const saveUrl: string = window.ETDR_RD.appConfig['UrlAction.RelatedClientsModalWindowSaveUrl'];

        const relatedClientsSettings: Classes.BootstrapModalWithAjaxContentSettings = GetRelatedClientsSettings();

        Modal.showBootstrapModalWithAjaxContent(relatedClientsSettings);

        function GetRelatedClientsSettings(): Classes.BootstrapModalWithAjaxContentSettings {
            let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

            settings.title = 'Érintettek kiválasztása';
            settings.contentUrl = contentUrl;
            settings.saveUrl = saveUrl;
            settings.callback = () => getRelatedClientsFromGridView();
            settings.infoText = '';
            settings.showRejectButton = false;
            settings.enableUnobtrusiveValidation = false;
            settings.saveText = 'Érintettek felvétele';
            settings.closeModalWindowAfterSave = false;

            return settings;
        }

        function getRelatedClientsFromGridView() {
            const grid: Interfaces.MVCxClientGridViewWithRelatedClientsInfos = window['TitleDeedPersons'] as Interfaces.MVCxClientGridViewWithRelatedClientsInfos;

            grid.cpIsSave = true;
            grid.PerformCallback('');
        }
    }
}

export function OnCheckedRealtiesEndCallback(s: Interfaces.MVCxClientGridViewForCheckedRealties, e) {
    toggleSelectAllCheckbox(s);
}

function toggleSelectAllCheckbox(s: Interfaces.MVCxClientGridViewWithSelectedKeys) {
    if (s.isCbSelectAllChecked) {
        const checkbox: JQuery<HTMLElement> = $('#cbSelectAll .dxWeb_edtCheckBoxUnchecked_ETDRTheme');

        if (checkbox) {
            checkbox.removeClass('dxWeb_edtCheckBoxUnchecked_ETDRTheme');
            checkbox.addClass('dxWeb_edtCheckBoxChecked_ETDRTheme');
        }
    }
}

export function getProcessIdFromPage() {
    return $('#procinfo-section').data('processid');
}

export function OnIsClientValueChanged(s, keyValue, url) {
    const processId: string = getProcessIdFromPage();

    $.ajax({
        method: "POST",
        url: url,
        data: { key: keyValue, value: s.GetValue(), processId: processId },
        headers: { Accept: 'application/json' }
    })
        .done((response: Interfaces.BaseJsonResponse) => {
            if (!response.success) {
                Modal.showErrorOnBootstrapModalWindow(response.errorText);
            }
        })
        .fail((jqXHR: JQueryXHR) => {
            let errorText: string;

            if (jqXHR.responseJSON.message) {
                errorText = jqXHR.responseJSON.message;
            } else {
                errorText = 'Hiba történt az Ügyfél érték frissítése során.';
            }

            Modal.showErrorOnBootstrapModalWindow(errorText);
        });
}

export function RelatedClientsBeginCallback(s: Interfaces.MVCxClientGridViewWithRelatedClientsInfos, e: MVCxClientBeginCallbackEventArgs) {
    if (s.cpIsSave) {
        disableSaveButton();
    }

    e.customArgs['selectedKeys'] = s.cpSelectedKeys;
    e.customArgs['isSave'] = s.cpIsSave;
    e.customArgs['processId'] = getProcessIdFromPage();

    function disableSaveButton(): void {
        let $saveButton: JQuery<HTMLElement> = $('#form-modal-save');
        $saveButton.attr('disabled', 'disabled');
        $saveButton.prepend('<span class="spinner-border spinner-border-md mr-2"></span>');
    }
}

export function OnRelatedClientsInit(s: Interfaces.MVCxClientGridViewWithRelatedClientsInfos, e: MVCxClientBeginCallbackEventArgs) {
    if (!s.cpIsAnyElement) {
        Modal.disableSaveButton();
    }
}

export function RelatedClientsEndCallback(s: Interfaces.MVCxClientGridViewWithRelatedClientsInfos, e: MVCxClientBeginCallbackEventArgs) {
    let $saveButton: JQuery<HTMLElement> = $('#form-modal-save');
    const callbackEndedWithSuccess: boolean = !s.cpIsCallbackError && s.cpHaveToCloseModalWindow;
    const isErrorDuringCallback: boolean = s.cpIsCallbackError;

    enableSaveButton();

    if (callbackEndedWithSuccess) {
        Modal.closeGenericModal();

        refreshRelatedClientsGrid();

        function refreshRelatedClientsGrid() {

            const grid: ASPxClientGridView = window['listErintettekItemModel'] as ASPxClientGridView;
            grid.Refresh();
        }
    }

    if (isErrorDuringCallback) {
        const errorText: string = s.cpErrorGuid ? `${s.cpErrorText} Hibaazonosító: ${s.cpErrorGuid}` : s.cpErrorText;

        disableSaveButton();
        Modal.showErrorOnBootstrapModalWindow(errorText);

        function disableSaveButton() {
            $saveButton.attr('disabled', 'disabled');
        }
    }

    toggleSelectAllCheckbox(s);

    function enableSaveButton() {
        $saveButton.removeAttr('disabled');
        $saveButton.children().remove();
    }
}

export function OnTakarnetModalGridRowSelectionChanged(s: Interfaces.MVCxClientGridViewWithSelectedKeys, e) {
    Helpers.OnGridRowSelectionChanged(s, e);
    Modal.ToggleModalSaveButtonStateByDxSelectionState(s, e);
}

$(() => {
    $(document).on('click', '#get-related-clients-from-takarnet', () => {
        CheckRealtiesStatuses();
    });
});
